// 为什么要建立一个index.js呢，因为我们在之后调用npm组件的时候，他会直接访问
// 这个index js文件

import pdfPreview from "./src/components/pdf-preview"
import _Vue from 'vue'

// 这一步判断window.Vue是否存在，因为直接引用vue.min.js， 它会把Vue绑到Window上，我们直接引用打包好的js才能正常跑起来。
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('pdf-preview', pdfPreview)
}
//这样就可以使用Vue.use进行全局安装了。
pdfPreview.install = Vue => {
  if (!Vue) {
    window.Vue = Vue = _Vue
  }
  Vue.component(pdfPreview.name, pdfPreview)
}
export default pdfPreview;



// WEBPACK FOOTER //
// ./index.js